/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  OutlinedInput,
  Stack,
  styled,
  TextField,
  Typography,
  useTheme,
  IconButton,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Pagination,
  Radio,
  AutocompleteRenderOptionState,
  AutocompleteRenderGetTagProps,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Link,
  Badge,
  Tooltip
} from '@mui/material';
import {
  ChangeEvent,
  FC,
  ReactNode,
  SyntheticEvent,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { withStyles } from '@mui/styles';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  initialState,
  reducerUpdateAdvanceSearch,
  reducerUpdateCommentingToPostDateRange,
  reducerUpdateCommentingToPostLabelList
} from 'src/features/advanceSearchSocialMedia';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import {
  IGranularity,
  ILabel,
  IRawPostmadeOutputEntity,
  IRawPostmadeOutputWithPagination,
  TContentType,
  TStringOperator,
  TPostOwnership,
  TSentiment,
  TValidation,
  ILanguage,
  TEmotion,
  TTalkType,
  TRetweetFilter,
  TAgeGeneration,
  IDateRange,
  TSearchScope
} from 'src/models/general';
import CheckboxCustomNl, { ChipCustom } from './CheckboxCustomNl';
import ModalSelectLabel from '../ModalSelectLabel';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentStream from './ContentStream';
import { useDebounce } from 'src/hooks/useDebounce';
import { useLazyQuery, useQuery } from '@apollo/client';
import { fillParamAdvanceSearchEmpty } from 'src/utils/fillParamAdvanceSearchEmpth';
import {
  GET_CONTENT_TOP_POSTMADE_PAGINATION,
  GET_CONTENT_TOP_TALK_POSTMADE_PAGINATION,
  GET_POSTMADE_STREAM_ID
} from 'src/services/graphql/content/query';
import CheckIcon from '@mui/icons-material/Check';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { RadioButtonChecked } from '@mui/icons-material';
import { correctDoubleSpaces } from 'src/utils/correctDoubleSpaces';
import { GET_LANGUAGES_V2 } from 'src/services/graphql/stream/query';
import { useAlert } from 'src/hooks/useAlert';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import separateNumberFormat from 'src/utils/separateNumberFormat';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ModalCustomTimeFrame from '../ModalCustomTimeFrame';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ProductTourTooltip from '../ProductTourTooltip';
import { useLocation } from 'react-router';

interface Props {
  open: boolean;
  onClose: () => void;
  objectIdList?: string[];
}

interface IOptionSentimentCheckbox {
  id: TSentiment;
  name: TSentiment;
  label: string;
  isChecked: boolean;
}

interface IOptionStreamTypeCheckbox {
  id: TPostOwnership;
  name: TPostOwnership;
  label: string;
  isChecked: boolean;
}

export interface IOptionTalkTypeCheckbox {
  id: TTalkType;
  name: TTalkType;
  label: string;
  isChecked: boolean;
}

export interface IOptionValidationCheckbox {
  id: TValidation;
  name: TValidation;
  label: string;
  isChecked: boolean;
}

interface IOptionPostTypeCheckbox {
  id: TContentType;
  name: TContentType;
  label: string;
  isChecked: boolean;
}

interface IOptionRatingCheckbox {
  id: number;
  name: number;
  label: string;
  isChecked: boolean;
}

interface IOptionEmotionCheckbox {
  id: TEmotion;
  name: TEmotion;
  label: string;
  isChecked: boolean;
}

interface IOptionAgeGenerationCheckbox {
  id: TAgeGeneration;
  name: TAgeGeneration;
  label: string;
  isChecked: boolean;
}

const CustomAutocomplete = withStyles({
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input':
      {
        padding: 0
      }
  }
})((props: any) => <Autocomplete {...props} />);

const CustomInput = withStyles((theme) => ({
  root: {
    borderRadius: '4px 0px 0px 4px',
    height: theme.spacing(5)
  }
}))(OutlinedInput);

const FabSmall = styled(Fab)(
  ({ theme }) => `
    min-height: unset;
    background-color: transparent;
    width: ${theme.spacing(3)};
    height: ${theme.spacing(3)};
    color: #E35200;
    border: 1px solid #E35200;

  `
);

export const retweetRadioOptions = [
  {
    value: 'all',
    label: 'All',
    ariaLabel: 'All'
  },
  {
    value: 'retweet',
    label: 'Retweets Only',
    ariaLabel: 'Retweet'
  },
  {
    value: 'onlyRelevantRt',
    label: (
      <>
        Retweets within timeframe <InfoOutlinedIcon sx={{ fontSize: 14 }} />
      </>
    ),
    ariaLabel: 'Relevant',
    tooltip:
      'Show only retweets of the original tweet within the selected timeframe.'
  },
  {
    value: 'excludeRt',
    label: 'Exclude Retweets',
    ariaLabel: 'Exclude'
  }
];

function renderRadioChip({ checked, label, theme }) {
  return (
    <ChipCustom
      variant="filled"
      deleteIcon={<CheckIcon />}
      label={
        <Stack direction="row" alignItems="center">
          {checked ? (
            <RadioButtonChecked
              sx={{
                mr: 1,
                width: 16,
                height: 16,
                color: theme.palette.primary.main
              }}
            />
          ) : (
            <PanoramaFishEyeIcon
              sx={{
                mr: 1,
                width: 16,
                height: 16,
                color: theme.palette.primary.main
              }}
            />
          )}
          <Typography
            variant="subtitle2"
            sx={{
              color: theme.palette.primary.main,
              fontSize: 13,
              fontWeight: 'normal'
            }}
          >
            {label}
          </Typography>
        </Stack>
      }
      size="small"
      sx={{
        background: theme.palette.primary.light,
        padding: '10px 56px 10px 8px'
      }}
      colorChip={theme.palette.common.black}
    />
  );
}

const AdvanceSearchSocialMedia: FC<Props> = ({
  open,
  onClose,
  objectIdList: objectIdListLocal
}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const isSocialMedia =
    pathname.split('/')[1] === 'social_media' ||
    pathname.split('/')[2] === 'social_media';

  const [openUsername, setOpenUsername] = useState<boolean>(false);
  const [openLanguages, setOpenLanguages] = useState<boolean>(false);
  const [openPosttype, setOpenPosttype] = useState<boolean>(false);
  const [openRetweet, setOpenRetweet] = useState<boolean>(false);
  const [openCommentingToPost, setOpenCommentingToPost] =
    useState<boolean>(false);
  const [openEmotion, setOpenEmotion] = useState<boolean>(false);
  const [openAgeGeneration, setOpenAgeGeneration] = useState<boolean>(false);
  const [openReviewRating, setOpenReviewRating] = useState<boolean>(false);
  const [openConfidenceScore, setOpenConfidenceScore] =
    useState<boolean>(false);

  const [anchorElLabelInclude, setAnchorElLabelInclude] =
    useState<HTMLDivElement | null>(null);

  const [anchorElLabelExclude, setAnchorElLabelExclude] =
    useState<HTMLDivElement | null>(null);

  const [
    anchorElLabelIncludeCommentingToPost,
    setAnchorElLabelIncludeCommentingToPost
  ] = useState<HTMLDivElement | null>(null);

  const handleClickLabelIncludeCommentingToPost = (event: any) => {
    setAnchorElLabelIncludeCommentingToPost(event.currentTarget);
  };

  const handleCloseLabelIncludeCommentingToPost = function () {
    setAnchorElLabelIncludeCommentingToPost(null);
  };

  const handleClickLabelInclude = (event: any) => {
    setAnchorElLabelInclude(event.currentTarget);
  };

  const handleCloseLabelInclude = function () {
    setAnchorElLabelInclude(null);
  };

  const handleClickLabelExclude = (event: any) => {
    setAnchorElLabelExclude(event.currentTarget);
  };

  const handleCloseLabelExclude = function () {
    setAnchorElLabelExclude(null);
  };

  const openLabelInclude = Boolean(anchorElLabelInclude);
  const openLabelExclude = Boolean(anchorElLabelExclude);
  const openLabelIncludeCommentingToPost = Boolean(
    anchorElLabelIncludeCommentingToPost
  );

  const {
    includeKeywords,
    excludeKeywords,
    sentiment,
    fromUsername,
    postOwnership,
    validationList,
    contentTypeList,
    labelList,
    excludeLabelList,
    sentimentConfidenceLevelMin,
    sentimentConfidenceLevelMax,
    showEmptyLabel,
    streamsCommentingToPost,
    selectedOriginalToPost,
    queryStringBooleanOperator,
    languageList,
    userRating,
    emotion: emotions,
    validationEmotionList: emotionValidationList,
    selectAllPrimaryPost,
    talkType,
    retweetFilter,
    ageGeneration,
    postMadeType,
    replyToOriginalId,
    commentingToPostDateRange,
    commentingToPostLabelList,
    searchScope
  } = useAppSelector((state) => state.storeAdvanceSearchSocialMedia);

  const [selectAllPrimaryLocal, setSelectAllPrimaryLocal] =
    useState(selectAllPrimaryPost);

  const { handleClickAlert } = useAlert();

  const { data: languages, loading: loadingLanguages } = useQuery<{
    languages_getLanguagesV2: ILanguage[];
  }>(GET_LANGUAGES_V2, {
    fetchPolicy: 'cache-first',
    onError: () => {
      handleClickAlert({
        horizontal: 'center',
        vertical: 'top',
        message: 'Error fetching languages',
        severity: 'error'
      });
    }
  });

  const isValueAvailable = function <T>(values: Array<T>, valString: T) {
    const value = values.find((value: T) => value === valString);
    return value ? true : false;
  };

  const isPositiveChecked = isValueAvailable<TSentiment>(sentiment, 'positive');
  const isNeutralChecked = isValueAvailable<TSentiment>(sentiment, 'neutral');
  const isNegativeChecked = isValueAvailable<TSentiment>(sentiment, 'negative');

  const isPostmadeChecked = isValueAvailable<TPostOwnership>(
    postOwnership,
    'postmade'
  );
  const isTalkChecked = isValueAvailable<TPostOwnership>(postOwnership, 'talk');
  const isReplyChecked = isValueAvailable<TPostOwnership>(
    postOwnership,
    'reply'
  );

  const isValidationChecked = isValueAvailable<TValidation>(
    validationList,
    'validated'
  );
  const isUnValidatedChecked = isValueAvailable<TValidation>(
    validationList,
    'unvalidated'
  );

  const isEmotionValidatedChecked = isValueAvailable<TValidation>(
    emotionValidationList,
    'validated'
  );
  const isEmotionUnValidatedChecked = isValueAvailable<TValidation>(
    emotionValidationList,
    'unvalidated'
  );

  const isContentTextChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'text'
  );
  const isContentImageChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'image'
  );
  const isContentVideoChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'video'
  );
  const isContentOthersChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'others'
  );

  const isPostChecked = isValueAvailable<TTalkType>(talkType, 'post');

  const isCommentChecked = isValueAvailable<TTalkType>(talkType, 'comment');

  const isRepostChecked = isValueAvailable<TTalkType>(talkType, 'repost');

  const isQuoteChecked = isValueAvailable<TTalkType>(talkType, 'quotes');

  const [includeKeywordsLocal, setIncludeKeywordsLocal] =
    useState<Array<string>>(includeKeywords);

  const [excludeKeywordsLocal, setExcludeKeywordsLocal] =
    useState<Array<string>>(excludeKeywords);

  const [usernameLocal, setUsernameLocal] = useState<string>(fromUsername);

  const getInitLanguages = () => {
    if (!languages || languageList.length <= 0) return [];
    return languages.languages_getLanguagesV2.filter((language) =>
      languageList.includes(language.language)
    );
  };

  const [languageListLocal, setLanguageListLocal] =
    useState<ILanguage[]>(getInitLanguages);

  const labels = useAppSelector((state) => state.storeLabel.labelList.data);
  const initialIncludeLabels = labels.filter((label) =>
    labelList?.includes(label.id)
  );
  const initialExcludeLabels = labels.filter((label) =>
    excludeLabelList?.includes(label.id)
  );
  const [includeLabelListLocal, setIncludeLabelListLocal] =
    useState<Array<ILabel>>(initialIncludeLabels);

  const [includeLabelCommentingToPost, setIncludeLabelCommentingToPost] =
    useState<ILabel[]>(commentingToPostLabelList);

  const [excludeLabelListLocal, setExcludeLabelListLocal] =
    useState<Array<ILabel>>(initialExcludeLabels);

  const [selectedOriginalToPostLocal, setSelectedOriginalToPostLocal] =
    useState<Array<IRawPostmadeOutputEntity>>(selectedOriginalToPost);

  const [
    sentimentConfidenceLevelMinLocal,
    setSentimentConfidenceLevelMinLocal
  ] = useState<number>(sentimentConfidenceLevelMin);

  const [
    sentimentConfidenceLevelMaxLocal,
    setSentimentConfidenceLevelMaxLocal
  ] = useState<number>(sentimentConfidenceLevelMax);

  const [showEmptyLabelLocal, setShowEmptyLabelLocal] =
    useState<boolean>(showEmptyLabel);

  const [sentimentOptions, setSentimentOptions] = useState<
    Array<IOptionSentimentCheckbox>
  >([
    {
      id: 'positive',
      name: 'positive',
      label: 'Positive',
      isChecked: isPositiveChecked
    },
    {
      id: 'neutral',
      name: 'neutral',
      label: 'Neutral',
      isChecked: isNeutralChecked
    },
    {
      id: 'negative',
      name: 'negative',
      label: 'Negative',
      isChecked: isNegativeChecked
    }
  ]);

  const [streamTypeOptions, setStreamTypeOptions] = useState<
    Array<IOptionStreamTypeCheckbox>
  >([
    {
      id: 'postmade',
      name: 'postmade',
      label: 'Postmade',
      isChecked: isPostmadeChecked
    },
    {
      id: 'talk',
      name: 'talk',
      label: 'Talk',
      isChecked: isTalkChecked
    },
    {
      id: 'reply',
      name: 'reply',
      label: 'Reply',
      isChecked: isReplyChecked
    }
  ]);

  const [talkTypeOptions, setTalkTypeOptions] = useState<
    Array<IOptionTalkTypeCheckbox>
  >([
    {
      id: 'post',
      name: 'post',
      label: 'Post',
      isChecked: isPostChecked
    },
    {
      id: 'comment',
      name: 'comment',
      label: 'Comment',
      isChecked: isCommentChecked
    },
    {
      id: 'repost',
      name: 'repost',
      label: 'Repost',
      isChecked: isRepostChecked
    }
    // {
    //   id: 'quotes',
    //   name: 'quotes',
    //   label: 'Quotes',
    //   isChecked: isQuoteChecked
    // }
  ]);

  // const [streamValidationLabel, setValidationLabel] = useState<
  //   Array<IOptionValidationCheckbox>
  // >([
  //   {
  //     id: 'validated',
  //     name: 'validated',
  //     label: 'Validated',
  //     isChecked: isValidationChecked
  //   }
  // ]);

  const [streamValidationOptions, setValidationOptions] = useState<
    Array<IOptionValidationCheckbox>
  >([
    {
      id: 'validated',
      name: 'validated',
      label: 'Validated',
      isChecked: isValidationChecked
    },
    {
      id: 'unvalidated',
      name: 'unvalidated',
      label: 'Unvalidated',
      isChecked: isUnValidatedChecked
    }
  ]);

  const [emotionValidationOptions, setEmotionValidationOptions] = useState<
    Array<IOptionValidationCheckbox>
  >([
    {
      id: 'validated',
      name: 'validated',
      label: 'Validated',
      isChecked: isEmotionValidatedChecked
    },
    {
      id: 'unvalidated',
      name: 'unvalidated',
      label: 'Unvalidated',
      isChecked: isEmotionUnValidatedChecked
    }
  ]);

  const [streamContentTypeOptions, setContentTypeOptions] = useState<
    Array<IOptionPostTypeCheckbox>
  >([
    {
      id: 'text',
      name: 'text',
      label: 'Text',
      isChecked: isContentTextChecked
    },
    {
      id: 'image',
      name: 'image',
      label: 'Image',
      isChecked: isContentImageChecked
    },
    {
      id: 'video',
      name: 'video',
      label: 'Video',
      isChecked: isContentVideoChecked
    },
    {
      id: 'others',
      name: 'others',
      label: 'Others',
      isChecked: isContentOthersChecked
    }
  ]);

  const [streamRatingOptions, setRatingOptions] = useState<
    Array<IOptionRatingCheckbox>
  >([
    {
      id: 1,
      name: 1,
      label: '1 ⭐️',
      isChecked: userRating.includes(1)
    },
    {
      id: 2,
      name: 2,
      label: '2 ⭐️⭐️',
      isChecked: userRating.includes(2)
    },
    {
      id: 3,
      name: 3,
      label: '3 ⭐️⭐️⭐️',
      isChecked: userRating.includes(3)
    },
    {
      id: 4,
      name: 4,
      label: '4 ⭐️⭐️⭐️⭐️',
      isChecked: userRating.includes(4)
    },
    {
      id: 5,
      name: 5,
      label: '5 ⭐️⭐️⭐️⭐️⭐️',
      isChecked: userRating.includes(5)
    }
  ]);

  const isJoyChecked = isValueAvailable<TEmotion>(emotions, 'joy');
  const isSadChecked = isValueAvailable<TEmotion>(emotions, 'sadness');
  const isAngerChecked = isValueAvailable<TEmotion>(emotions, 'anger');
  const isProudChecked = isValueAvailable<TEmotion>(emotions, 'proud');
  const isTrustChecked = isValueAvailable<TEmotion>(emotions, 'trust');
  const isFearChecked = isValueAvailable<TEmotion>(emotions, 'fear');
  const isSurprisedChecked = isValueAvailable<TEmotion>(emotions, 'surprised');
  const isEmptyEmotionChecked = isValueAvailable<TEmotion>(
    emotions,
    'emptyEmotion'
  );

  const isGenerationXChecked = isValueAvailable<TAgeGeneration>(
    ageGeneration,
    'generation_x'
  );
  const isGenerationZChecked = isValueAvailable<TAgeGeneration>(
    ageGeneration,
    'generation_z'
  );
  const isMillennialsChecked = isValueAvailable<TAgeGeneration>(
    ageGeneration,
    'millennials'
  );
  const isBabyBoomersChecked = isValueAvailable<TAgeGeneration>(
    ageGeneration,
    'baby_boomers'
  );

  const isEmptyGenerationChecked = isValueAvailable<TAgeGeneration>(
    ageGeneration,
    'empty_age_generation'
  );

  const [emotionsLocal, setEmotionsLocal] = useState<
    Array<IOptionEmotionCheckbox>
  >([
    {
      id: 'joy',
      name: 'joy',
      label: 'Joy',
      isChecked: isJoyChecked
    },
    {
      id: 'sadness',
      name: 'sadness',
      label: 'Sadness',
      isChecked: isSadChecked
    },
    {
      id: 'anger',
      name: 'anger',
      label: 'Anger',
      isChecked: isAngerChecked
    },
    {
      id: 'fear',
      name: 'fear',
      label: 'Fear',
      isChecked: isFearChecked
    },
    {
      id: 'surprised',
      name: 'surprised',
      label: 'Surprised',
      isChecked: isSurprisedChecked
    },
    { id: 'proud', name: 'proud', label: 'Proud', isChecked: isProudChecked },
    { id: 'trust', name: 'trust', label: 'Trust', isChecked: isTrustChecked },
    {
      id: 'emptyEmotion',
      name: 'emptyEmotion',
      label: 'Empty',
      isChecked: isEmptyEmotionChecked
    }
  ]);

  const [ageGenerationLocal, setAgeGenerationLocal] = useState<
    Array<IOptionAgeGenerationCheckbox>
  >([
    {
      id: 'generation_x',
      name: 'generation_x',
      label: 'Generation X',
      isChecked: isGenerationXChecked
    },
    {
      id: 'generation_z',
      name: 'generation_z',
      label: 'Generation Z',
      isChecked: isGenerationZChecked
    },
    {
      id: 'millennials',
      name: 'millennials',
      label: 'Millennials',
      isChecked: isMillennialsChecked
    },
    {
      id: 'baby_boomers',
      name: 'baby_boomers',
      label: 'Baby Boomers',
      isChecked: isBabyBoomersChecked
    },
    {
      id: 'empty_age_generation',
      name: 'empty_age_generation',
      label: 'Empty',
      isChecked: isEmptyGenerationChecked
    }
  ]);

  const [streams, setStreams] = useState<IRawPostmadeOutputWithPagination>(
    streamsCommentingToPost
  );

  const [queryStringBooleanOperatorLocal, setQueryStringBooleanOperatorLocal] =
    useState<TStringOperator>(queryStringBooleanOperator);

  const [retweetFilterLocal, setRetweetFilterLocal] =
    useState<TRetweetFilter>(retweetFilter);

  const handleChangeKeywordMode = (event: any) => {
    setQueryStringBooleanOperatorLocal(event.target.value);
  };

  const handleChangeSearchScope = (event: any) => {
    setSearchScopeLocal(event.target.value);
  };

  const handleChangeRetweetFilter = (event: any) => {
    setRetweetFilterLocal(event.target.value);
  };

  const handleSearchIncludes = (value: string[]) => {
    const removedDobleSpaceStrings = value.map((text) =>
      correctDoubleSpaces(text)
    );
    setIncludeKeywordsLocal(removedDobleSpaceStrings);
  };

  const handleSearchExcludes = (value: string[]) => {
    const removedDobleSpaceStrings = value.map((text) =>
      correctDoubleSpaces(text)
    );
    setExcludeKeywordsLocal(removedDobleSpaceStrings);
  };

  const handleChangeOption = (prev, optionId) =>
    prev.map((option) => {
      if (option.id === optionId)
        return { ...option, isChecked: !option.isChecked };
      return option;
    });

  const handleClickSentiment = (optionId: TSentiment) => {
    setSentimentOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickStreamType = (optionId: TPostOwnership) => {
    setStreamTypeOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickTalkType = (optionId: TTalkType) => {
    setTalkTypeOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickValidation = (optionId: TValidation) => {
    setValidationOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickEmotionValidation = (optionId: TValidation) => {
    setEmotionValidationOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickContentType = (optionId: TContentType) => {
    setContentTypeOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickRating = (optionId: string) => {
    setRatingOptions((prev) => handleChangeOption(prev, parseInt(optionId)));
  };

  const handleClickEmotion = (optionId: TEmotion) => {
    setEmotionsLocal((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickAgeGeneration = (optionId: TAgeGeneration) => {
    setAgeGenerationLocal((prev) => handleChangeOption(prev, optionId));
  };

  const handleChangeConfidenceScoreMin = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.persist();
    let value = parseFloat(event.target.value);
    if (value > 1) value = 1;
    if (value < 0) value = 0;
    setSentimentConfidenceLevelMinLocal(value);
  };

  const handleChangeConfidenceScoreMax = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.persist();
    let value = parseFloat(event.target.value);
    if (value > 1) value = 1;
    if (value < 0) value = 0;
    setSentimentConfidenceLevelMaxLocal(value);
  };

  const handleDiscard = () => {
    setIncludeKeywordsLocal([]);
    setExcludeKeywordsLocal([]);
    setUsernameLocal('');
    setIncludeLabelListLocal([]);
    setExcludeLabelListLocal([]);
    setSentimentConfidenceLevelMinLocal(0);
    setSentimentConfidenceLevelMaxLocal(1);
    setSelectedOriginalToPostLocal([]);
    setStreams({
      result: [],
      totalRows: 0,
      totalPages: 0,
      page: 1,
      limit: 20
    });
    setSentimentOptions([
      {
        id: 'positive',
        name: 'positive',
        label: 'Positive',
        isChecked: false
      },
      {
        id: 'neutral',
        name: 'neutral',
        label: 'Neutral',
        isChecked: false
      },
      {
        id: 'negative',
        name: 'negative',
        label: 'Negative',
        isChecked: false
      }
    ]);
    setStreamTypeOptions([
      {
        id: 'postmade',
        name: 'postmade',
        label: 'Postmade',
        isChecked: false
      },
      {
        id: 'talk',
        name: 'talk',
        label: 'Talk',
        isChecked: false
      },
      {
        id: 'reply',
        name: 'reply',
        label: 'Reply',
        isChecked: false
      }
    ]);
    setValidationOptions([
      {
        id: 'validated',
        name: 'validated',
        label: 'Validated',
        isChecked: false
      },
      {
        id: 'unvalidated',
        name: 'unvalidated',
        label: 'Unvalidated',
        isChecked: false
      }
    ]);
    setEmotionValidationOptions([
      {
        id: 'validated',
        name: 'validated',
        label: 'Validated',
        isChecked: false
      },
      {
        id: 'unvalidated',
        name: 'unvalidated',
        label: 'Unvalidated',
        isChecked: false
      }
    ]);
    setContentTypeOptions([
      {
        id: 'text',
        name: 'text',
        label: 'Text',
        isChecked: false
      },
      {
        id: 'image',
        name: 'image',
        label: 'Image',
        isChecked: false
      },
      {
        id: 'video',
        name: 'video',
        label: 'Video',
        isChecked: false
      },
      {
        id: 'others',
        name: 'others',
        label: 'Others',
        isChecked: false
      }
    ]);
    setEmotionsLocal([
      {
        id: 'joy',
        name: 'joy',
        label: 'joy',
        isChecked: false
      },
      {
        id: 'sadness',
        name: 'sadness',
        label: 'Sadness',
        isChecked: false
      },
      {
        id: 'anger',
        name: 'anger',
        label: 'Anger',
        isChecked: false
      },
      {
        id: 'fear',
        name: 'fear',
        label: 'Fear',
        isChecked: false
      },
      {
        id: 'surprised',
        name: 'surprised',
        label: 'Surprised',
        isChecked: false
      },
      {
        id: 'proud',
        name: 'proud',
        label: 'Proud',
        isChecked: false
      },
      {
        id: 'trust',
        name: 'trust',
        label: 'Trust',
        isChecked: false
      }
    ]);
    setAgeGenerationLocal([
      {
        id: 'generation_x',
        name: 'generation_x',
        label: 'Generation X',
        isChecked: false
      },
      {
        id: 'generation_z',
        name: 'generation_z',
        label: 'Generation Z',
        isChecked: false
      },
      {
        id: 'millennials',
        name: 'millennials',
        label: 'Millennials',
        isChecked: false
      },
      {
        id: 'baby_boomers',
        name: 'baby_boomers',
        label: 'Baby Boomers',
        isChecked: false
      }
    ]);
    setQueryStringBooleanOperatorLocal('and');
    setLanguageListLocal([]);
    setRatingOptions([
      {
        id: 1,
        name: 1,
        label: '1 ⭐️',
        isChecked: false
      },
      {
        id: 2,
        name: 2,
        label: '2 ⭐️⭐️',
        isChecked: false
      },
      {
        id: 3,
        name: 3,
        label: '3 ⭐️⭐️⭐️',
        isChecked: false
      },
      {
        id: 4,
        name: 4,
        label: '4 ⭐️⭐️⭐️⭐️',
        isChecked: false
      },
      {
        id: 5,
        name: 5,
        label: '5 ⭐️⭐️⭐️⭐️⭐️',
        isChecked: false
      }
    ]);
    setSelectAllPrimaryLocal(false);
    setTalkTypeOptions([
      {
        id: 'post',
        name: 'post',
        label: 'Post',
        isChecked: false
      },
      {
        id: 'comment',
        name: 'comment',
        label: 'Comment',
        isChecked: false
      },
      {
        id: 'repost',
        name: 'repost',
        label: 'Repost',
        isChecked: false
      }
      // {
      //   id: 'quotes',
      //   name: 'quotes',
      //   label: 'Quotes',
      //   isChecked: false
      // }
    ]);
    setRetweetFilterLocal('all');
    setPostMadeTypeLocal('postmade');
    setCommentingToPostDateRangeLocal(initialState.commentingToPostDateRange);
    setIncludeLabelCommentingToPost(initialState.commentingToPostLabelList);
    setSearchScopeLocal('content');
  };

  // for date range label
  const dateRangeOptionActive = useAppSelector(
    (state) => state.analyticArguments.dateRangeOptionActive
  );

  const dateRangeLabel = () => {
    // if (dateRangeOptionActive.id !== 'custom') {
    //   return dateRangeOptionActive.label;
    // }
    return `${moment(commentingToPostDateRangeLocal.start).format(
      'L HH:mm'
    )} - ${moment(commentingToPostDateRangeLocal.end).format('L HH:mm')}`;
  };

  const handleDone = () => {
    // const sentiments = sentimentOptions
    //   .filter((sentiment) => sentiment.isChecked)
    //   .map((sen) => sen.id);
    //
    dispatch(
      reducerUpdateCommentingToPostDateRange(commentingToPostDateRangeLocal)
    );
    dispatch(
      reducerUpdateCommentingToPostLabelList(includeLabelCommentingToPost)
    );
    dispatch(
      reducerUpdateAdvanceSearch({
        includeKeywords: includeKeywordsLocal,
        excludeKeywords: excludeKeywordsLocal,
        fromUsername: usernameLocal,
        sentiment: sentimentOptions
          .filter((sentiment) => sentiment.isChecked)
          .map((sentiment) => sentiment.id),
        postOwnership: streamTypeOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        contentTypeList: streamContentTypeOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        validationList: streamValidationOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        talkType: talkTypeOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        labelList: includeLabelListLocal.map((label) => label.id),
        excludeLabelList: excludeLabelListLocal.map((label) => label.id),
        sentimentConfidenceLevelMin: sentimentConfidenceLevelMinLocal,
        sentimentConfidenceLevelMax: sentimentConfidenceLevelMaxLocal,
        showEmptyLabel: showEmptyLabelLocal,
        replyToOriginalId: selectAllPrimaryLocal
          ? postmadeIdsData?.content_getStreamOriginalIdPostmade ??
            replyToOriginalId
          : selectedOriginalToPostLocal.map((stream) => stream.originalId),
        streamsCommentingToPost: streams,
        selectedOriginalToPost: selectedOriginalToPostLocal,
        searchOriginalToPost: debouncedState,
        queryStringBooleanOperator: queryStringBooleanOperatorLocal,
        languageList: languageListLocal.map((item) => item.language),
        userRating: streamRatingOptions
          .filter((rating) => rating.isChecked)
          .map((rating) => rating.id),
        emotion: emotionsLocal
          .filter((emotion) => emotion.isChecked)
          .map((emotion) => emotion.id),
        validationEmotionList: emotionValidationOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        selectAllPrimaryPost: selectAllPrimaryLocal,
        retweetFilter: retweetFilterLocal,
        ageGeneration: ageGenerationLocal
          .filter((age) => age.isChecked)
          .map((age) => age.id),
        postMadeType: postMadeTypeLocal,
        searchScope: searchScopeLocal
      })
    );
    onClose();
  };

  const [debouncedState, setDebouncedState] = useDebounce('');
  const [searchFormValue, setSearchFormValue] = useState('');

  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const keyword = event.target.value;
    setSearchFormValue(keyword);
    setDebouncedState(() => keyword);
  };

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
    if (postMadeTypeLocal === 'postmade') {
      refetchContentTopPostmade({
        ...finalPayload,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        limit,
        page: newPage
      });
    } else {
      refetchContentTopTalkPostmade({
        ...finalPayload,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        talkType: ['post'],
        limit,
        page: newPage
      });
    }
  };

  const handleChangeLimit = (e: SelectChangeEvent<number>) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);

    if (page !== 1) setPage(1);
    if (postMadeTypeLocal === 'postmade') {
      refetchContentTopPostmade({
        ...finalPayload,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        limit: newLimit,
        page: 1
      });
    } else {
      refetchContentTopTalkPostmade({
        ...finalPayload,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        talkType: ['post'],
        limit: newLimit,
        page: 1
      });
    }
  };

  const handleDeleteSearch = () => {
    setSearchFormValue('');
    setDebouncedState(() => '');
  };

  const projectId = useAppSelector((state) => state.users.project.id);
  const { dateRangeFormatted, objectIdList } = useAppSelector(
    (state) => state.analyticArguments
  );

  const granularity: IGranularity = {
    unit: 'day',
    value: 1
  };

  const isOriginalPostSelected = (id: string) =>
    selectedOriginalToPostLocal.findIndex((obj) => obj.originalId === id) !==
    -1;

  const totalSelectedPost = selectedOriginalToPostLocal.length;
  const totalRowsPerPage = streams.result.length;

  const handleClickOriginalPost = function (label: IRawPostmadeOutputEntity) {
    const selectedIndex = selectedOriginalToPostLocal.findIndex(
      (obj) => obj.originalId === label.originalId
    );
    let newSelected: IRawPostmadeOutputEntity[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedOriginalToPostLocal, label);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedOriginalToPostLocal.slice(1));
    } else if (selectedIndex === selectedOriginalToPostLocal.length - 1) {
      newSelected = newSelected.concat(
        selectedOriginalToPostLocal.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedOriginalToPostLocal.slice(0, selectedIndex),
        selectedOriginalToPostLocal.slice(selectedIndex + 1)
      );
    }
    setSelectedOriginalToPostLocal(newSelected);
  };

  const handleClickSelectAllPosts = (
    e: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (checked) {
      setSelectedOriginalToPostLocal(streams.result);
    } else {
      if (selectAllPrimaryLocal) setSelectAllPrimaryLocal(false);
      setSelectedOriginalToPostLocal([]);
    }
  };

  const fillAdvanceSearchSocialMedia = useMemo(() => {
    return fillParamAdvanceSearchEmpty(initialState);
  }, [initialState]);

  const timezone = useAppSelector((state) => state.users.project.timezone);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [postMadeTypeLocal, setPostMadeTypeLocal] = useState<
    'postmade' | 'talk'
  >(postMadeType);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [commentingToPostDateRangeLocal, setCommentingToPostDateRangeLocal] =
    useState<IDateRange>(commentingToPostDateRange);
  const [searchScopeLocal, setSearchScopeLocal] =
    useState<TSearchScope>(searchScope);

  const commentingToPostFormattedDateRange = useMemo(() => {
    return {
      start: moment(commentingToPostDateRangeLocal.start).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      end: moment(commentingToPostDateRangeLocal.end).format(
        'YYYY-MM-DD HH:mm:ss'
      )
    };
  }, [commentingToPostDateRangeLocal]);

  const finalPayload = {
    ...fillAdvanceSearchSocialMedia,
    projectId,
    ...commentingToPostFormattedDateRange,
    objectList: objectIdListLocal ?? objectIdList,
    granularity,
    timezone
  };

  const handleClickPostTimeframe = () => {
    setOpenDatePicker(true);
  };

  const handleClosePostTimeframe = () => {
    setOpenDatePicker(false);
  };

  const handleChangeTimeframe = (dateRange: IDateRange): void => {
    setCommentingToPostDateRangeLocal(dateRange);
    setOpenDatePicker(false);
  };

  const handlePostMadeTypeChange = (event: SelectChangeEvent<string>) => {
    const newType = event.target.value as 'postmade' | 'talk';
    setPostMadeTypeLocal(newType);
    setSelectAllPrimaryLocal(false);
    setSelectedOriginalToPostLocal([]);

    // Refetch data with new type
    if (newType === 'postmade') {
      refetchContentTopPostmade({
        ...finalPayload,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        limit,
        page: 1
      });
    } else {
      refetchContentTopTalkPostmade({
        ...finalPayload,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        talkType: ['post'],
        limit,
        page: 1
      });
    }

    // Reset page to 1 when switching types
    if (page !== 1) setPage(1);
  };

  const {
    refetch: refetchContentTopPostmade,
    loading: contentTopPostmadeLoading
  } = useQuery(GET_CONTENT_TOP_POSTMADE_PAGINATION, {
    variables: {
      ...finalPayload,
      includeKeywords: debouncedState === '' ? [] : [debouncedState],
      labelList: includeLabelCommentingToPost.map((label) => label.id),
      limit: limit,
      page: 1
    },
    onCompleted: ({ content_getTopPostMadeWithPaginationV2 }) => {
      setStreams(content_getTopPostMadeWithPaginationV2);
      // setSelectAllPrimaryLocal(false);
    },
    fetchPolicy: 'network-only',
    skip: postMadeTypeLocal === 'talk'
  });

  const {
    refetch: refetchContentTopTalkPostmade,
    loading: contentTopTalkPostmadeLoading
  } = useQuery(GET_CONTENT_TOP_TALK_POSTMADE_PAGINATION, {
    variables: {
      ...finalPayload,
      includeKeywords: debouncedState === '' ? [] : [debouncedState],
      labelList: includeLabelCommentingToPost.map((label) => label.id),
      talkType: ['post'],
      limit: limit,
      page: 1
    },
    onCompleted: ({ content_getTopTalkPostMadeWithPagination }) => {
      setStreams(content_getTopTalkPostMadeWithPagination);
      // setSelectAllPrimaryLocal(false);
    },
    fetchPolicy: 'network-only',
    skip: postMadeTypeLocal === 'postmade'
  });

  const [
    getPostmadeIds,
    { data: postmadeIdsData, loading: postmadeIdsLoading }
  ] = useLazyQuery<{
    content_getStreamOriginalIdPostmade: string[];
  }>(GET_POSTMADE_STREAM_ID, {
    fetchPolicy: 'cache-first',
    onError: () => {
      handleClickAlert({
        message: 'Error selecting all post, please try again',
        horizontal: 'center',
        vertical: 'top',
        severity: 'error'
      });
      setSelectAllPrimaryLocal(false);
    }
  });

  const handleClickSelectAllPrimary = (selected: boolean) => {
    if (!selected) {
      setSelectAllPrimaryLocal(false);
      return;
    }
    setSelectAllPrimaryLocal(true);
    getPostmadeIds({
      variables: {
        ...finalPayload,
        postOwnership:
          postMadeTypeLocal === 'postmade' ? ['postmade'] : ['talk'],
        talkType:
          postMadeTypeLocal === 'talk' ? ['post'] : finalPayload.talkType,
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        page: 1,
        limit: 100
      }
    });
  };

  const renderLanguageOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: ILanguage,
    { selected }: AutocompleteRenderOptionState
  ) => {
    const handleChange = (
      e: ChangeEvent<HTMLInputElement>,
      checked: boolean
    ) => {
      if (option.language === 'all') {
        if (checked)
          setLanguageListLocal(languages?.languages_getLanguagesV2 ?? []);
        else setLanguageListLocal([]);
      }
    };

    const isIndeterminate =
      languageListLocal.length > 0 &&
      languageListLocal.length !==
        (languages?.languages_getLanguagesV2.length ?? 0);

    const isChecked =
      option.language !== 'all'
        ? selected
        : languageListLocal.length ===
          (languages?.languages_getLanguagesV2.length ?? 0);

    return (
      <Box
        {...props}
        key={option.language}
        component="li"
        sx={{
          '&.MuiAutocomplete-option[aria-selected="true"], &.MuiAutocomplete-option[aria-selected="true"].Mui-focused':
            {
              backgroundColor: 'white'
            }
        }}
      >
        <Checkbox
          size="small"
          style={{ marginRight: 8 }}
          checked={isChecked}
          onChange={handleChange}
          indeterminate={option.language === 'all' && isIndeterminate}
        />
        {option.name}
      </Box>
    );
  };

  const renderLanguageTags = (
    values: ILanguage[],
    getTagProps: AutocompleteRenderGetTagProps
  ): ReactNode => {
    if (values.length > 6) {
      return (
        <>
          {values.slice(0, 6).map((option: ILanguage, index: number) => (
            <Chip
              key={`${option}-${index}-includes`}
              variant="outlined"
              label={<Typography>{option.name}</Typography>}
              size="small"
              {...getTagProps({ index })}
            />
          ))}
          <Chip
            key={`rest`}
            variant="outlined"
            label={<Typography>+{values.length - 6}</Typography>}
            size="small"
          />
        </>
      );
    }
    return values.map((option: ILanguage, index: number) => (
      <Chip
        key={`${option}-${index}-includes`}
        variant="outlined"
        label={<Typography>{option.name}</Typography>}
        size="small"
        {...getTagProps({ index })}
      />
    ));
  };

  const handleSwapIncludeExclude = () => {
    const temp = includeKeywordsLocal;
    setIncludeKeywordsLocal(excludeKeywordsLocal);
    setExcludeKeywordsLocal(temp);
  };

  useEffect(() => {
    if (debouncedState !== searchFormValue) {
      if (page !== 1) setPage(1);

      if (postMadeTypeLocal === 'postmade') {
        refetchContentTopPostmade({
          ...finalPayload,
          includeKeywords: debouncedState === '' ? [] : [debouncedState],
          labelList: includeLabelCommentingToPost.map((label) => label.id),
          limit,
          page: 1
        });
      } else {
        refetchContentTopTalkPostmade({
          ...finalPayload,
          includeKeywords: debouncedState === '' ? [] : [debouncedState],
          labelList: includeLabelCommentingToPost.map((label) => label.id),
          talkType: ['post'],
          limit,
          page: 1
        });
      }
    }
  }, [debouncedState]);

  useEffect(() => {
    setIncludeKeywordsLocal(includeKeywords);
  }, [includeKeywords]);

  useEffect(() => {
    setUsernameLocal(fromUsername);
  }, [fromUsername]);

  const tfStyle = {
    '& .MuiButtonBase-root.MuiAutocomplete-clearIndicator': {
      color: 'blue',
      visibility: 'visible'
    }
  };

  const {
    isOnTour,
    currentTour: { stepNumber, menu, submenu }
  } = useAppSelector((state) => state.storeProductTour);

  const isCurrentlyOnTourStep13 =
    isOnTour &&
    stepNumber === 13 &&
    menu === 'social-media' &&
    submenu === 'overview';
  const keywordRef = useRef(null);

  return (
    <>
      <Dialog
        onClose={!isOnTour ? onClose : undefined}
        open={open}
        fullWidth
        maxWidth={'md'}
      >
        <IconButton
          aria-label="close"
          onClick={!isOnTour ? onClose : undefined}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <ProductTourTooltip
          open={isCurrentlyOnTourStep13}
          placement="right"
          maxWidth={180}
          onClick={onClose}
          onClose={onClose}
        >
          <DialogTitle
            sx={{
              m: !isOnTour ? theme.spacing(3, 3, 0) : undefined,
              p: theme.spacing(2, 2, 0, 2)
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 600,
                fontSize: 20,
                textAlign: 'left'
              }}
            >
              Advance Search
            </Typography>
          </DialogTitle>
        </ProductTourTooltip>
        <DialogContent
          sx={{
            m: { mb: theme.spacing(1, 2) }
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                Includes
              </Typography>
              <CustomAutocomplete
                multiple
                id="keyword-includes"
                size="small"
                options={[]}
                defaultValue={[]}
                freeSolo
                ref={keywordRef}
                value={includeKeywordsLocal}
                renderTags={(values: Array<any>, getTagProps) =>
                  values.map((option: string, index: number) => (
                    <Chip
                      key={`${option}-${index}-includes`}
                      variant="outlined"
                      label={<Typography>{option}</Typography>}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))
                }
                onChange={(_e, value) => {
                  handleSearchIncludes(value);
                }}
                forcePopupIcon={false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="includes"
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    placeholder="Separated by Enter"
                    sx={{ tfStyle }}
                    onPaste={(event) => {
                      const keywords = event.clipboardData.getData('text');
                      const splitKeyword = keywords.split(',');
                      const trimAndFilterKeyword = splitKeyword
                        .filter((word) => word.trim().length > 1)
                        .map((word) => word.trim());

                      const value = [
                        ...includeKeywordsLocal,
                        ...trimAndFilterKeyword
                      ];
                      handleSearchIncludes(value);
                    }}
                  />
                )}
              />
            </Grid>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              width="100%"
              py={1}
            >
              <IconButton
                size="small"
                onClick={handleSwapIncludeExclude}
                sx={{
                  margin: theme.spacing(0, 1.5),
                  border: '1px solid #009FE333',
                  backgroundColor: '#E7F3F7',
                  marginBottom: '-20px',
                  borderRadius: '8px'
                }}
              >
                <SwapVertIcon />
              </IconButton>
            </Stack>
            <Grid item sx={{ pt: '0 !important' }} xs={12}>
              <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                Excludes
              </Typography>
              <CustomAutocomplete
                multiple
                id="keyword-includes"
                size="small"
                options={[]}
                defaultValue={[]}
                freeSolo
                value={excludeKeywordsLocal}
                renderTags={(values: Array<any>, getTagProps) =>
                  values.map((option: string, index: number) => (
                    <Chip
                      key={`${option}-${index}-includes`}
                      variant="outlined"
                      label={<Typography>{option}</Typography>}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))
                }
                onChange={(_e, value) => {
                  handleSearchExcludes(value);
                }}
                forcePopupIcon={false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="includes"
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    placeholder="Separated by Enter"
                    onPaste={(event) => {
                      const keywords = event.clipboardData.getData('text');
                      const splitKeyword = keywords.split(',');
                      const trimAndFilterKeyword = splitKeyword
                        .filter((word) => word.trim().length > 1)
                        .map((word) => word.trim());
                      const value = [
                        ...excludeKeywordsLocal,
                        ...trimAndFilterKeyword
                      ];
                      handleSearchExcludes(value);
                    }}
                  />
                )}
              />
            </Grid>
            {isSocialMedia && (
              <Grid item lg={12}>
                <Typography
                  id="searchBy"
                  sx={{ mb: theme.spacing(0.5) }}
                  variant="h5"
                >
                  Search By
                </Typography>
                <Stack direction="row" flexWrap="wrap" gap={2}>
                  <Radio
                    checked={searchScopeLocal === 'content'}
                    value="content"
                    size="small"
                    inputProps={{ 'aria-label': 'content' }}
                    onChange={handleChangeSearchScope}
                    checkedIcon={
                      <ChipCustom
                        variant="filled"
                        deleteIcon={<CheckIcon />}
                        label={
                          <Stack direction="row" alignItems="center">
                            <RadioButtonChecked
                              sx={{
                                mr: 1,
                                width: 16,
                                height: 16,
                                color: theme.palette.primary.main
                              }}
                            />{' '}
                            <Typography
                              variant="subtitle2"
                              sx={{
                                color: theme.palette.primary.main,
                                fontSize: 13,
                                fontWeight: 'normal'
                              }}
                            >
                              Content Only
                            </Typography>
                          </Stack>
                        }
                        size="small"
                        sx={{
                          background: theme.palette.primary.light,
                          padding: '10px 56px 10px 8px'
                        }}
                        colorChip={theme.palette.common.black}
                      />
                    }
                    icon={
                      <ChipCustom
                        variant="filled"
                        deleteIcon={<CheckIcon />}
                        label={
                          <Stack direction="row" alignItems="center">
                            <PanoramaFishEyeIcon
                              sx={{
                                mr: 1,
                                width: 16,
                                height: 16,
                                color: theme.palette.primary.main
                              }}
                            />{' '}
                            <Typography
                              variant="subtitle2"
                              sx={{
                                color: theme.palette.primary.main,
                                fontSize: 13,
                                fontWeight: 'normal'
                              }}
                            >
                              Content Only
                            </Typography>
                          </Stack>
                        }
                        size="small"
                        sx={{
                          background: theme.palette.primary.light,
                          padding: '10px 56px 10px 8px'
                        }}
                        colorChip={theme.palette.common.black}
                      />
                    }
                  />
                  <Radio
                    checked={searchScopeLocal === 'contentAndTranscript'}
                    value="contentAndTranscript"
                    size="small"
                    inputProps={{ 'aria-label': 'contentAndTranscript' }}
                    onChange={handleChangeSearchScope}
                    checkedIcon={
                      <ChipCustom
                        variant="filled"
                        deleteIcon={<CheckIcon />}
                        label={
                          <Stack direction="row" alignItems="center">
                            <RadioButtonChecked
                              sx={{
                                mr: 1,
                                width: 16,
                                height: 16,
                                color: theme.palette.primary.main
                              }}
                            />{' '}
                            <Typography
                              variant="subtitle2"
                              sx={{
                                color: theme.palette.primary.main,
                                fontSize: 13,
                                fontWeight: 'normal'
                              }}
                            >
                              Content & Transcript Post
                            </Typography>
                          </Stack>
                        }
                        size="small"
                        sx={{
                          background: theme.palette.primary.light,
                          padding: '10px 56px 10px 8px'
                        }}
                        colorChip={theme.palette.common.black}
                      />
                    }
                    icon={
                      <ChipCustom
                        variant="filled"
                        deleteIcon={<CheckIcon />}
                        label={
                          <Stack direction="row" alignItems="center">
                            <PanoramaFishEyeIcon
                              sx={{
                                mr: 1,
                                width: 16,
                                height: 16,
                                color: theme.palette.primary.main
                              }}
                            />{' '}
                            <Typography
                              variant="subtitle2"
                              sx={{
                                color: theme.palette.primary.main,
                                fontSize: 13,
                                fontWeight: 'normal'
                              }}
                            >
                              Content & Transcript Post
                            </Typography>
                          </Stack>
                        }
                        size="small"
                        sx={{
                          background: theme.palette.primary.light,
                          padding: '10px 56px 10px 8px'
                        }}
                        colorChip={theme.palette.common.black}
                      />
                    }
                  />
                </Stack>
              </Grid>
            )}
            <Grid item lg={12}>
              <Typography
                id="keywordMode"
                sx={{ mb: theme.spacing(0.5) }}
                variant="h5"
              >
                Mode for Includes & Excludes
              </Typography>
              <Stack direction="row" flexWrap="wrap" gap={2}>
                <Radio
                  checked={queryStringBooleanOperatorLocal === 'and'}
                  value="and"
                  size="small"
                  inputProps={{ 'aria-label': 'And' }}
                  onChange={handleChangeKeywordMode}
                  checkedIcon={
                    <ChipCustom
                      variant="filled"
                      deleteIcon={<CheckIcon />}
                      label={
                        <Stack direction="row" alignItems="center">
                          <RadioButtonChecked
                            sx={{
                              mr: 1,
                              width: 16,
                              height: 16,
                              color: theme.palette.primary.main
                            }}
                          />{' '}
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: theme.palette.primary.main,
                              fontSize: 13,
                              fontWeight: 'normal'
                            }}
                          >
                            And
                          </Typography>
                        </Stack>
                      }
                      size="small"
                      sx={{
                        background: theme.palette.primary.light,
                        padding: '10px 56px 10px 8px'
                      }}
                      colorChip={theme.palette.common.black}
                    />
                  }
                  icon={
                    <ChipCustom
                      variant="filled"
                      deleteIcon={<CheckIcon />}
                      label={
                        <Stack direction="row" alignItems="center">
                          <PanoramaFishEyeIcon
                            sx={{
                              mr: 1,
                              width: 16,
                              height: 16,
                              color: theme.palette.primary.main
                            }}
                          />{' '}
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: theme.palette.primary.main,
                              fontSize: 13,
                              fontWeight: 'normal'
                            }}
                          >
                            And
                          </Typography>
                        </Stack>
                      }
                      size="small"
                      sx={{
                        background: theme.palette.primary.light,
                        padding: '10px 56px 10px 8px'
                      }}
                      colorChip={theme.palette.common.black}
                    />
                  }
                />
                <Radio
                  checked={queryStringBooleanOperatorLocal === 'or'}
                  value="or"
                  size="small"
                  inputProps={{ 'aria-label': 'Or' }}
                  onChange={handleChangeKeywordMode}
                  checkedIcon={
                    <ChipCustom
                      variant="filled"
                      deleteIcon={<CheckIcon />}
                      label={
                        <Stack direction="row" alignItems="center">
                          <RadioButtonChecked
                            sx={{
                              mr: 1,
                              width: 16,
                              height: 16,
                              color: theme.palette.primary.main
                            }}
                          />{' '}
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: theme.palette.primary.main,
                              fontSize: 13,
                              fontWeight: 'normal'
                            }}
                          >
                            Or
                          </Typography>
                        </Stack>
                      }
                      size="small"
                      sx={{
                        background: theme.palette.primary.light,
                        padding: '10px 56px 10px 8px'
                      }}
                      colorChip={theme.palette.common.black}
                    />
                  }
                  icon={
                    <ChipCustom
                      variant="filled"
                      deleteIcon={<CheckIcon />}
                      label={
                        <Stack direction="row" alignItems="center">
                          <PanoramaFishEyeIcon
                            sx={{
                              mr: 1,
                              width: 16,
                              height: 16,
                              color: theme.palette.primary.main
                            }}
                          />{' '}
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: theme.palette.primary.main,
                              fontSize: 13,
                              fontWeight: 'normal'
                            }}
                          >
                            Or
                          </Typography>
                        </Stack>
                      }
                      size="small"
                      sx={{
                        background: theme.palette.primary.light,
                        padding: '10px 56px 10px 8px'
                      }}
                      colorChip={theme.palette.common.black}
                    />
                  }
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ pt: '16px !important' }}>
              <Accordion
                expanded={openUsername}
                onChange={() => setOpenUsername(!openUsername)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Username
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openUsername ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="@example"
                    onChange={(e) => setUsernameLocal(e.target.value)}
                    value={usernameLocal}
                  />
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} sx={{ pt: '8px !important' }}>
              <Accordion
                expanded={openLanguages}
                onChange={() => setOpenLanguages(!openLanguages)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Languages
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openLanguages ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Autocomplete<ILanguage, true, false, false>
                    size="small"
                    multiple
                    id="language-list"
                    options={
                      !isOnTour
                        ? [
                            {
                              language: 'all',
                              name: 'Select All'
                            } as ILanguage,
                            ...(languages?.languages_getLanguagesV2 ?? [])
                          ]
                        : []
                    }
                    loading={loadingLanguages}
                    disableCloseOnSelect
                    fullWidth
                    value={languageListLocal}
                    onChange={(_: SyntheticEvent, newValue) => {
                      // Check if the new selection includes the "all" option
                      const hasAllOption = newValue.some(
                        (lang) => lang.language === 'all'
                      );

                      if (hasAllOption) {
                        const allSelected =
                          languageListLocal.length ===
                          (languages?.languages_getLanguagesV2.length ?? 0);
                        setLanguageListLocal(
                          allSelected
                            ? []
                            : languages?.languages_getLanguagesV2 ?? []
                        );
                      } else {
                        setLanguageListLocal(newValue as ILanguage[]);
                      }
                    }}
                    ListboxProps={{ style: { padding: 0 } }}
                    getOptionLabel={(option) => option.name}
                    renderTags={renderLanguageTags}
                    renderOption={renderLanguageOption}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={
                          languageListLocal.length <= 0 ? 'All languages' : null
                        }
                      />
                    )}
                  />
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item lg={12} sx={{ pt: '16px !important' }}>
              <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                Sentiment Validation
              </Typography>
              <Stack direction="row" flexWrap="wrap" alignItems="center">
                {streamValidationOptions.map((option) => (
                  <CheckboxCustomNl
                    {...option}
                    key={option.id}
                    onClick={handleClickValidation}
                  />
                ))}
              </Stack>
            </Grid>
            <Grid item lg={12}>
              <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                Sentiment
              </Typography>
              <Stack direction="row" flexWrap="wrap" alignItems="center">
                {sentimentOptions.map((option) => (
                  <CheckboxCustomNl
                    {...option}
                    key={option.id}
                    onClick={handleClickSentiment}
                  />
                ))}
              </Stack>
            </Grid>
            <Grid item lg={12}>
              <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                Stream Type
              </Typography>
              <Stack direction="row" flexWrap="wrap" alignItems="center">
                {streamTypeOptions.map((option) => (
                  <CheckboxCustomNl
                    {...option}
                    key={option.id}
                    onClick={handleClickStreamType}
                  />
                ))}
              </Stack>
            </Grid>
            <Grid item lg={12}>
              <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                Talk Type
              </Typography>
              <Stack direction="row" flexWrap="wrap" alignItems="center">
                {talkTypeOptions.map((option) => (
                  <CheckboxCustomNl
                    {...option}
                    key={option.id}
                    onClick={handleClickTalkType}
                  />
                ))}
              </Stack>
            </Grid>
            <Grid item lg={12} sx={{ pt: '16px !important' }}>
              <Accordion
                expanded={openPosttype}
                onChange={() => setOpenPosttype(!openPosttype)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Post Type
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openPosttype ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Stack direction="row" flexWrap="wrap" alignItems="center">
                    {streamContentTypeOptions.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        key={option.id}
                        onClick={handleClickContentType}
                      />
                    ))}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item sm={12} sx={{ pt: '8px !important' }}>
              <Accordion
                expanded={openRetweet}
                onChange={() => setOpenRetweet(!openRetweet)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Retweet
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openRetweet ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Stack direction="row" gap={2} flexWrap="wrap">
                    {retweetRadioOptions.map((option) => {
                      const radio = (
                        <Radio
                          key={option.value}
                          checked={retweetFilterLocal === option.value}
                          value={option.value}
                          size="small"
                          inputProps={{ 'aria-label': option.ariaLabel }}
                          onChange={handleChangeRetweetFilter}
                          checkedIcon={renderRadioChip({
                            checked: true,
                            label: option.label,
                            theme
                          })}
                          icon={renderRadioChip({
                            checked: false,
                            label: option.label,
                            theme
                          })}
                        />
                      );
                      return option.tooltip ? (
                        <Tooltip
                          arrow
                          title={option.tooltip}
                          key={option.value}
                        >
                          {radio}
                        </Tooltip>
                      ) : (
                        radio
                      );
                    })}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} sx={{ pt: '16px !important' }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: theme.spacing(1) }}
              >
                <Typography variant="h5">Include Label</Typography>
                {includeLabelListLocal.length > 0 && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{ maxHeight: theme.spacing(3.5) }}
                    onClick={handleClickLabelInclude}
                  >
                    Select +
                  </Button>
                )}
              </Stack>
              <Box
                sx={{
                  background: '#FBFBFB',
                  borderRadius: theme.spacing(1),
                  maxHeight: theme.spacing(9 * 4)
                }}
              >
                {includeLabelListLocal.length < 1 && (
                  <Stack
                    direction="row"
                    flexWrap="wrap"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <CheckboxCustomNl
                      id="unlabeled"
                      label="Unlabeled"
                      name="setShowEmptyLabelLocal"
                      isChecked={showEmptyLabelLocal}
                      onClick={() =>
                        setShowEmptyLabelLocal(!showEmptyLabelLocal)
                      }
                    />
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={!isOnTour ? handleClickLabelInclude : undefined}
                      sx={{ margin: theme.spacing(2, 1.5) }}
                    >
                      Select Label
                    </Button>
                  </Stack>
                )}
                <Box
                  sx={{
                    maxHeight: theme.spacing(25),
                    overflow: 'auto'
                  }}
                >
                  {includeLabelListLocal.length > 0 &&
                    includeLabelListLocal.map((label) => (
                      <Box
                        sx={{
                          padding: theme.spacing(1, 2)
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          spacing={1}
                        >
                          <Box sx={{ maxWidth: '70%' }}>
                            <Typography>{label.displayName}</Typography>
                          </Box>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={3}
                          >
                            <Stack direction={'row'}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 500,
                                  fontSize: 13
                                }}
                              >
                                {moment(label.createdAt).format(
                                  'ddd, MMM DD YYYY, HH:mm'
                                )}
                              </Typography>
                            </Stack>
                            <FabSmall
                              size="small"
                              sx={{
                                marginLeft: theme.spacing(2)
                              }}
                            >
                              <DeleteIcon
                                sx={{
                                  fontSize: theme.spacing(1.5)
                                }}
                                onClick={() =>
                                  setIncludeLabelListLocal((prev) =>
                                    prev.filter(
                                      (prevLabel) => prevLabel.id !== label.id
                                    )
                                  )
                                }
                              />
                            </FabSmall>
                          </Stack>
                        </Stack>
                      </Box>
                    ))}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: theme.spacing(1) }}
              >
                <Typography variant="h5">Exclude Label</Typography>
                {excludeLabelListLocal.length > 0 && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{ maxHeight: theme.spacing(3.5) }}
                    onClick={handleClickLabelExclude}
                  >
                    Select +
                  </Button>
                )}
              </Stack>
              <Box
                sx={{
                  background: '#FBFBFB',
                  borderRadius: theme.spacing(1),
                  maxHeight: theme.spacing(9 * 4)
                }}
              >
                {excludeLabelListLocal.length < 1 && (
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={!isOnTour ? handleClickLabelExclude : undefined}
                      sx={{ margin: theme.spacing(2, 1.5) }}
                    >
                      Select Label
                    </Button>
                  </Stack>
                )}
                <Box
                  sx={{
                    maxHeight: theme.spacing(25),
                    overflow: 'auto'
                  }}
                >
                  {excludeLabelListLocal.length > 0 &&
                    excludeLabelListLocal.map((label) => (
                      <Box
                        sx={{
                          padding: theme.spacing(1, 2)
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          spacing={1}
                        >
                          <Box sx={{ maxWidth: '70%' }}>
                            <Typography>{label.displayName}</Typography>
                          </Box>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={3}
                          >
                            <Stack direction={'row'}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 500,
                                  fontSize: 13
                                }}
                              >
                                {moment(label.createdAt).format(
                                  'ddd, MMM DD YYYY, HH:mm'
                                )}
                              </Typography>
                            </Stack>
                            <FabSmall
                              size="small"
                              sx={{
                                marginLeft: theme.spacing(2)
                              }}
                            >
                              <DeleteIcon
                                sx={{
                                  fontSize: theme.spacing(1.5)
                                }}
                                onClick={() =>
                                  setExcludeLabelListLocal((prev) =>
                                    prev.filter(
                                      (prevLabel) => prevLabel.id !== label.id
                                    )
                                  )
                                }
                              />
                            </FabSmall>
                          </Stack>
                        </Stack>
                      </Box>
                    ))}
                </Box>
              </Box>
            </Grid>
            <Grid item lg={12} sx={{ pt: '16px !important' }}>
              <Accordion
                expanded={openEmotion}
                onChange={() => setOpenEmotion(!openEmotion)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Emotion Validation
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openEmotion ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Stack direction="row" flexWrap="wrap" alignItems="center">
                    {emotionValidationOptions.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        key={option.id}
                        onClick={handleClickEmotionValidation}
                      />
                    ))}
                  </Stack>
                  <Stack spacing={2} sx={{ px: 0, py: 2 }}>
                    <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                      Emotion
                    </Typography>
                    <Stack
                      direction="row"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={2}
                    >
                      {emotionsLocal.map((option) => (
                        <CheckboxCustomNl
                          {...option}
                          key={option.id}
                          onClick={handleClickEmotion}
                        />
                      ))}
                    </Stack>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item lg={12} sx={{ pt: '8px !important' }}>
              <Accordion
                expanded={openAgeGeneration}
                onChange={() => setOpenAgeGeneration(!openAgeGeneration)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Age Generation
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openAgeGeneration ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    gap={2}
                  >
                    {ageGenerationLocal.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        key={option.id}
                        onClick={handleClickAgeGeneration}
                      />
                    ))}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item lg={12} sx={{ pt: '8px !important' }}>
              <Accordion
                expanded={openReviewRating}
                onChange={() => setOpenReviewRating(!openReviewRating)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Review Rating
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openReviewRating ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    rowGap={2}
                  >
                    {streamRatingOptions.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        id={option.id.toString()}
                        name={option.name.toString()}
                        key={option.id}
                        onClick={handleClickRating}
                      />
                    ))}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} sx={{ pt: '8px !important' }}>
              <Accordion
                expanded={openCommentingToPost}
                onChange={() => setOpenCommentingToPost(!openCommentingToPost)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Commenting to Post
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openCommentingToPost ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      sx={{ overflow: 'scroll', width: '100%' }}
                    >
                      <Box
                        sx={{
                          background: theme.colors.primary.main,
                          borderRadius: '12px 12px 0px 0px',
                          padding: theme.spacing(1.2),
                          overflow: 'scroll',
                          width: '100%',
                          minWidth: '900px'
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={isOnTour ? { pointerEvents: 'none' } : {}}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  totalSelectedPost - totalRowsPerPage === 0
                                }
                                onChange={handleClickSelectAllPosts}
                                sx={{
                                  color: 'white',
                                  '&.Mui-checked': { color: 'white' }
                                }}
                                indeterminate={
                                  totalSelectedPost > 0 &&
                                  totalSelectedPost < totalRowsPerPage
                                }
                                indeterminateIcon={
                                  <IndeterminateCheckBoxIcon
                                    sx={{
                                      color: theme.palette.common.white
                                      // width: theme.spacing(2.5),
                                      // height: theme.spacing(2.5)
                                    }}
                                  />
                                }
                              />
                            }
                            label=""
                          />
                          <Stack
                            direction="row"
                            justifyContent="end"
                            width="100%"
                            gap={4}
                            alignItems="center"
                          >
                            <FormControl variant="outlined" size="small">
                              {/*<InputLabel id="postmade-type-label">Type</InputLabel>*/}
                              <Select
                                // labelId="postmade-type-label"
                                id="postmade-type-select"
                                value={postMadeTypeLocal}
                                onChange={handlePostMadeTypeChange}
                                label="Type"
                                sx={{
                                  backgroundColor: '#ffffff',
                                  minWidth: 120
                                }}
                              >
                                <MenuItem value="postmade">Postmade</MenuItem>
                                <MenuItem value="talk">Talk</MenuItem>
                              </Select>
                            </FormControl>
                            <Badge
                              badgeContent={includeLabelCommentingToPost.length}
                              color="info"
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                              }}
                            >
                              <Button
                                onClick={(e) =>
                                  handleClickLabelIncludeCommentingToPost(e)
                                }
                                variant="text"
                                sx={{ color: '#fff', padding: 0 }}
                                size="small"
                                startIcon={<FilterAltIcon />}
                              >
                                Filter by label
                              </Button>
                            </Badge>
                            <TextField
                              id="search"
                              variant="outlined"
                              placeholder="Search"
                              size="small"
                              sx={{
                                // width: '50%',
                                backgroundColor: '#ffffff',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                flexGrow: 1
                              }}
                              value={searchFormValue}
                              onChange={handleChangeSearch}
                              InputProps={{
                                endAdornment: debouncedState ? (
                                  <IconButton
                                    size="small"
                                    onClick={handleDeleteSearch}
                                  >
                                    <ClearIcon />
                                  </IconButton>
                                ) : undefined
                              }}
                            />
                            <Stack
                              direction="row"
                              gap={1}
                              sx={{
                                cursor: 'pointer'
                              }}
                              onClick={handleClickPostTimeframe}
                            >
                              <CalendarMonthIcon sx={{ color: '#ffffff' }} />
                              <Typography
                                variant="caption"
                                // component="button"

                                sx={{
                                  color: '#FBFBFB',
                                  marginLeft: '0 !important'
                                }}
                              >
                                {`Viewing post within ${dateRangeLabel()}`}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Box>
                      {totalSelectedPost > 0 ? (
                        <Stack
                          width="100%"
                          direction="row"
                          alignItems="center"
                          sx={{
                            backgroundColor: '#EDEDED',
                            padding: 1
                          }}
                        >
                          <Typography variant="subtitle2" fontWeight={700}>
                            {selectAllPrimaryLocal
                              ? `All ${streams.totalRows} posts in primary are selected.`
                              : totalSelectedPost === totalRowsPerPage
                              ? 'All 20 posts on this table are selected.'
                              : `${totalSelectedPost} / ${streams.totalRows} total posts`}
                          </Typography>
                          {totalSelectedPost === totalRowsPerPage ? (
                            <Link
                              sx={{ color: theme.colors.primary.main }}
                              component={Button}
                              size="small"
                              onClick={() =>
                                handleClickSelectAllPrimary(
                                  !selectAllPrimaryLocal
                                )
                              }
                              disabled={postmadeIdsLoading}
                            >
                              {!selectAllPrimaryLocal
                                ? `Select all ${separateNumberFormat(
                                    streams.totalRows
                                  )} posts in primary`
                                : postmadeIdsLoading
                                ? 'Selecting all posts..'
                                : `Clear selection`}
                            </Link>
                          ) : null}
                        </Stack>
                      ) : null}
                      <Box
                        sx={{
                          maxHeight: theme.spacing(40),
                          borderRadius: '0 0 12px 12px',
                          background: '#F5F5F5'
                        }}
                      >
                        {contentTopPostmadeLoading ||
                        contentTopTalkPostmadeLoading ? (
                          <Box
                            justifyContent="center"
                            display="flex"
                            alignItems="center"
                            sx={{
                              height: theme.spacing(40),
                              width: '100%'
                            }}
                          >
                            <CircularProgress size={52} />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              maxHeight: theme.spacing(40),
                              background: '#ffffff',
                              overflow: 'auto',
                              border: '1px solid #F5F5F5',
                              borderRadius: '0 0 12px 12px',
                              padding: theme.spacing(1)
                            }}
                          >
                            {streams.result.map((stream) => (
                              <FormControlLabel
                                sx={{
                                  width: '100%',
                                  ...(isOnTour && { pointerEvents: 'none' })
                                }}
                                key={stream.originalId}
                                label={
                                  <ContentStream
                                    originalId={stream.originalId}
                                    account={stream.fromName}
                                    link={stream.link}
                                    image={stream.displayPicture}
                                    status={stream.content}
                                    socialMedia={stream.socialMedia}
                                  />
                                }
                                control={
                                  <Checkbox
                                    onChange={
                                      !isOnTour
                                        ? () => {
                                            handleClickOriginalPost(stream);
                                          }
                                        : undefined
                                    }
                                    disabled={selectAllPrimaryLocal}
                                    checked={
                                      selectAllPrimaryLocal ||
                                      isOriginalPostSelected(stream.originalId)
                                    }
                                  />
                                }
                              />
                            ))}
                          </Box>
                        )}
                      </Box>
                    </Grid>
                    <Grid item sm={12}>
                      <Stack direction="row" justifyContent="center">
                        <FormControl variant="outlined" size="small">
                          <InputLabel id="select-limit-label">Limit</InputLabel>
                          <Select
                            labelId="select-limit-label"
                            id="select-limit"
                            value={limit}
                            onChange={!isOnTour ? handleChangeLimit : undefined}
                            label="Limit"
                            disabled={
                              contentTopPostmadeLoading ||
                              contentTopTalkPostmadeLoading
                            }
                          >
                            {[10, 20, 50, 100].map((limit) => (
                              <MenuItem value={limit} key={limit}>
                                {limit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Pagination
                          count={streams.totalPages}
                          // sx={{ mx: 'auto' }}
                          shape="rounded"
                          color="primary"
                          size="large"
                          page={streams.page}
                          onChange={!isOnTour ? handleChangePage : undefined}
                          disabled={
                            contentTopPostmadeLoading ||
                            contentTopTalkPostmadeLoading
                          }
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} sx={{ pt: '8px !important' }}>
              <Accordion
                expanded={openConfidenceScore}
                onChange={() => setOpenConfidenceScore(!openConfidenceScore)}
                sx={{ border: 0 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <Typography
                    sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                    variant="h5"
                  >
                    Confidence Score
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.secondary'
                    }}
                  >
                    {openConfidenceScore ? 'Hide' : 'Show'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={
                    isOnTour
                      ? { pointerEvents: 'none', padding: 0 }
                      : { padding: 0 }
                  }
                >
                  <Grid item lg={12}>
                    <Grid container spacing={3}>
                      <Grid item lg={6}>
                        <Typography
                          sx={{ mb: theme.spacing(0.5) }}
                          variant="h5"
                        >
                          From
                        </Typography>
                        <CustomInput
                          value={sentimentConfidenceLevelMinLocal}
                          fullWidth
                          onChange={handleChangeConfidenceScoreMin}
                          type="number"
                          inputProps={{ min: 0, max: 1, step: '0.1' }}
                        />
                      </Grid>
                      <Grid item lg={6}>
                        <Typography
                          sx={{ mb: theme.spacing(0.5) }}
                          variant="h5"
                        >
                          To
                        </Typography>
                        <CustomInput
                          value={sentimentConfidenceLevelMaxLocal}
                          fullWidth
                          onChange={handleChangeConfidenceScoreMax}
                          type="number"
                          inputProps={{ min: 0, max: 1, step: '0.1' }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Stack
            spacing={2}
            justifyContent="center"
            display="flex"
            direction="row"
            sx={{ mt: theme.spacing(3) }}
          >
            <Button
              variant="outlined"
              sx={{
                width: theme.spacing(20)
              }}
              onClick={!isOnTour ? handleDiscard : undefined}
              size="medium"
            >
              Discard
            </Button>
            <Button
              variant="contained"
              sx={{
                width: theme.spacing(20)
              }}
              onClick={!isOnTour ? handleDone : undefined}
              size="medium"
              disabled={postmadeIdsLoading}
            >
              Done
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
      <ModalCustomTimeFrame
        onClose={handleClosePostTimeframe}
        onSet={handleChangeTimeframe}
        open={openDatePicker}
        initDateRange={commentingToPostDateRange}
      />
      <ModalSelectLabel
        title="Select Include Label"
        open={openLabelInclude}
        onClose={handleCloseLabelInclude}
        onSubmit={(labels) => {
          handleCloseLabelInclude();
          setIncludeLabelListLocal(labels);
        }}
        prevSelectedLabels={includeLabelListLocal}
      />
      <ModalSelectLabel
        title="Include Label for Commenting to Post"
        open={openLabelIncludeCommentingToPost}
        onClose={handleCloseLabelIncludeCommentingToPost}
        onSubmit={(labels) => {
          handleCloseLabelIncludeCommentingToPost();
          setIncludeLabelCommentingToPost(labels);
        }}
        prevSelectedLabels={includeLabelCommentingToPost}
      />
      <ModalSelectLabel
        title="Select Exclude Label"
        open={openLabelExclude}
        onClose={handleCloseLabelExclude}
        onSubmit={(labels) => {
          handleCloseLabelExclude();
          setExcludeLabelListLocal(labels);
        }}
        prevSelectedLabels={excludeLabelListLocal}
      />
    </>
  );
};

export default AdvanceSearchSocialMedia;
